import { EquipmentListContext } from 'app/components/ReactContexts/equipmentListContext';
import { MenuAndContent, SubmenuAndContent } from 'app/components/layouts';
import useFlag from 'app/hooks/useFlag';
import { EquipmentList } from 'app/pages/Equipment/EquipmentList';
import { EquipmentNotLoaded } from 'app/pages/Equipment/EquipmentNotLoaded';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { invitationsApi } from 'services/api/invitations/queries';
import { initialSharesState, sharesApi } from 'services/api/shares';
import { FeatureName } from 'types/entities/MobileSettings';

interface Props {
  submenu: JSX.Element;
}

export default function EquipmentEmptyStateLayout({ submenu }: Props) {
  const { equipmentListData } = React.useContext(EquipmentListContext);
  const isAccessSharingPageEnabled = useFlag(FeatureName.ACCESS_SHARING);

  const {
    data: invitations = {
      pendingReceivedInvitations: [],
      pendingSentInvitations: [],
    },
  } = invitationsApi.useGetInvitationsQuery(undefined, {
    skip: !isAccessSharingPageEnabled,
  });

  const { data: { equipment, fleets } = initialSharesState } =
    sharesApi.useGetSharesQuery();

  const hasAnyShares = equipment.length || fleets.length;
  const hasAnyInvitations = invitations.pendingReceivedInvitations.length;

  const renderContentOrEmptyState = (comp: JSX.Element) => {
    if (!equipmentListData?.equipmentList) {
      return (
        <MenuAndContent>
          <EquipmentNotLoaded />
        </MenuAndContent>
      );
    }

    if (equipmentListData.equipmentList.length > 0) return comp;

    return hasAnyInvitations || hasAnyShares ? (
      <SubmenuAndContent submenu={<EquipmentList />}>
        <EquipmentNotLoaded />
      </SubmenuAndContent>
    ) : (
      <MenuAndContent>
        <EquipmentNotLoaded />
      </MenuAndContent>
    );
  };

  return renderContentOrEmptyState(
    <SubmenuAndContent submenu={submenu}>
      <Outlet />
    </SubmenuAndContent>,
  );
}
